module.exports = __webpack_public_path__ + "img/posible.3f06446f.png";